import {Component, ContentChild, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef} from '@angular/core';
import {HttpModelConverter} from '../../converter/httpModel.converter';
import {UntypedFormGroup} from '@angular/forms';
import {SelectFilterElement} from '../../../../components/common/select-filter/select-filter.model';
import {BehaviorSubject, Subscription} from 'rxjs';
import {Sort, UrlParameter} from '../../../../shared/utils/url.builder';
import {SelectEntityCollectionReadOnlyService} from '../../service/selectEntityCollectionReadOnlyService';
import {ContentDirective} from '../../../../shared/directives/content.directive';
import {NewItemModalOptions} from '../select/abstract-select.component';
import {AbstractFindAllService} from '../../service/v2/service/findAll/abstractFindAll.service';

@Component({
    selector: 'app-multiple-select-filter-data',
    templateUrl: './multiple-select-filter-data.component.html'
})
export class MultipleSelectFilterDataComponent<Model, Converter extends HttpModelConverter<Model>> implements OnInit, OnDestroy, OnChanges {

    @Input() service: SelectEntityCollectionReadOnlyService<Model, Converter> | AbstractFindAllService<any, Model>;
    @Input() parentFormControlName: string;
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() noEntriesFoundLabel: string;
    @Input() filterElementProcessor: (criteria: string, element: any) => boolean;

    @Input() loadOnInit = false;
    @Input() additionalUrlParameters: UrlParameter[] = [];
    @Input() sort: Sort;
    @Input() resolveSelectFilterElement: (entity: Model) => SelectFilterElement<string | number, Model>;
    @Input() newItemModalOptions: NewItemModalOptions<any, any, any>;

    @ContentChild(ContentDirective, {static: true, read: TemplateRef}) template: TemplateRef<any>;

    loading = false;
    elements: BehaviorSubject<SelectFilterElement<string | number, Model>[]>
        = new BehaviorSubject<SelectFilterElement<string | number, Model>[]>([]);
    subscriptions: Subscription[] = [];

    constructor() {
    }

    ngOnInit() {
        this.subscriptions.push(this.service.entities$.subscribe(entities => {
            this.elements.next(entities.map(value => this.resolveSelectFilterElement(value)));
        }));

        this.subscriptions.push(this.service.loading$.subscribe(value => this.loading = value));
        this.refresh();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(value => value.unsubscribe());
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['sort'] && !changes['sort'].isFirstChange()) {
            this.refresh();
        }
        if (changes['additionalUrlParameters'] && !changes['additionalUrlParameters'].isFirstChange()) {
            this.refresh();
        }
    }


    refresh() {
        if (this.service instanceof SelectEntityCollectionReadOnlyService) {
            this.service.findAll(this.additionalUrlParameters, this.sort);
        } else {
            this.service.additionalParameters = this.additionalUrlParameters;
            this.service.sort = this.sort;
            this.service.refresh();
        }

    }


}
